<section class="cst_body">
  <div class="container-fluid search_flt_box_main">
    <form [formGroup]="searchForm" (ngSubmit)="search(searchForm)">
      <div class="search_flt_box">
        <div class="row">
          <div class="col-2">
            <div class="form-group">
              <label for="formGroupExampleInput">Search By Business</label>
              <select id="inputState" class="form-control col-form-label-sm" formControlName="businessId">
                <option [ngValue]="null" disabled>Select</option>
                <option *ngFor="let businessoption of businessOptions" [value]="businessoption.value">{{
                  businessoption.label }}</option>
              </select>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label>Status</label>
              <select id="inputState" class="form-control col-form-label-sm" formControlName="status">
                <option [ngValue]="null" disabled>Select</option>
                <option *ngFor="let data of reimbursementStatusList" [ngValue]="data.statusCode">{{data.status}}
                </option>
              </select>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="formGroupExampleInput">Search By</label>
              <select id="inputState" class="form-control col-form-label-sm" formControlName="searchBy">
                <option [ngValue]="null" disabled>Select</option>
                <option>Transaction ID</option>
                <option>Claim ID</option>
              </select>
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label for="formGroupExampleInput">Enter Value</label>
              <input type="text" class="form-control col-form-label-sm" formControlName="searchByValue"
                placeholder="Enter Value">
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <label>Select Daterange:</label>
              <div class="input-group">

                <input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker [bsValue]="bsRangeValue"
                  (bsValueChange)="onValueChange($event)">
                <div class="input-group-append">
                  <button class="btn btn-success" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen"
                    type="button"><i class="fa fa-calendar" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-2 padLftRht6">
            <button type="submit" class="btn green_btn">Search</button>&nbsp;
            <button class="btn green_btn" (click)="clear()">Clear</button>
          </div>


        </div>
      </div>
    </form>

  </div>
  <div class="container-fluid" role="main">
    <div class="table_main tableShadow">
      <!--<div class="tbl_name">
        All Reimbursement <span class="fnt-medium">({{datacount}})</span>
      </div>-->
      <table class="table table-striped table-responsive">
        <thead>
          <tr  class="tbl_name">
            <th>Claim ID</th>
            <th>Transaction Id</th>
            <th>Emp Id</th>
            <th>MRN</th>
            <th>Customer Name</th>
            <th>Business Name</th>
            <th>Bill Amount</th>
            <th>Claim Amount</th>
            <th>Approved Amount</th>
            <th>Claim Status</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reimbursListObj of reimbursListRes;let i = index">

            <td>{{reimbursListObj.claimId}}</td>
            <td>{{reimbursListObj.transactionId}}</td>
            <td>{{reimbursListObj.employeeId}}</td>
            <td>{{reimbursListObj.mrn}}</td>
            <td>{{reimbursListObj.customerName}}</td>
            <td>{{reimbursListObj.businessName}}</td>
            <td>{{reimbursListObj.lineitemAmount}}</td>
            <td>{{reimbursListObj.requestedAmount}}</td>
            <td>{{reimbursListObj.approvedAmount}}</td>
            <td>{{reimbursListObj.claimStatus}}</td>
            <td>{{reimbursListObj.createdDate | date:'dd/MM/yyyy hh:mm a'}}</td>
            <td>
              <img class="exitImg" src="./assets/img/eye.png"
                (click)="getReimbursById(reimbursListObj.transactionId,reimbursListObj.claimId)"
                ngbTooltip="View Details">&nbsp;
              <img class="exitImg" src="./assets/img/info.png"
                (click)="opentrackReimbursementModal(reimbursListObj.transactionId,reimbursListObj.claimId)"
                ngbTooltip="Track History" />
            </td>

          </tr>

        </tbody>
      </table>

    </div>
    <!--<div class="col-12" *ngIf="reimbursListRes?.length">

      <ngb-pagination [collectionSize]="datacount" [(page)]="page" [pageSize]="pageSize" [maxSize]="5"
        [boundaryLinks]="true" class="d-flex justify-content-end customPagination" (pageChange)="pageChange(page)">
      </ngb-pagination>

    </div>-->
    <div  class="noRecord" *ngIf="reimbursListRes?.length == 0"><b>No Records Found</b></div>
    <div class="col-12 tableBottom" *ngIf="reimbursListRes?.length">
      <div class="totalRecords">
        Total Reimbursements <span class="fnt-medium">({{datacount}})</span>
      </div>
     <div>
      <ngb-pagination [collectionSize]="datacount" [(page)]="page" [pageSize]="pageSize" [maxSize]="5"
      [boundaryLinks]="true" class=" customPagination" (pageChange)="pageChange(page)">
    </ngb-pagination>
     </div>
     </div>

  </div>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>


</section>